module.exports = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',

  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',
};



//////////////////
// WEBPACK FOOTER
// ./~/react-dates/constants.js
// module id = 11
// module chunks = 0